import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Shield, AlertTriangle, CheckCircle } from "lucide-react";

interface InputRestrictionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

export default function InputRestrictionsDialog({ 
  open, 
  onOpenChange, 
  onConfirm,
  title = "Content Policy Violation",
  message = "Your input contains inappropriate content that violates our community guidelines."
}: InputRestrictionsDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center space-x-2">
            <Shield className="w-5 h-5 text-red-500" />
            <AlertDialogTitle className="text-red-700">{title}</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-gray-600 space-y-3">
            <p>{message}</p>
            
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <div className="flex items-start space-x-2">
                <AlertTriangle className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <p className="font-medium text-red-800 mb-2">What's not allowed:</p>
                  <ul className="text-red-700 space-y-1 text-xs">
                    <li>• Profanity, offensive language, or slurs</li>
                    <li>• Violence, threats, or hate speech</li>
                    <li>• Drug references or illegal activities</li>
                    <li>• Spam, inappropriate content, or harassment</li>
                    <li>• Discriminatory or derogatory terms</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
              <div className="flex items-start space-x-2">
                <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <p className="font-medium text-green-800 mb-1">Please use:</p>
                  <p className="text-green-700 text-xs">Respectful, appropriate language that creates a positive environment for all users.</p>
                </div>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            className="w-full"
          >
            I'll Fix It
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
